import { StoreFont, StoreFontFamily } from '@/types';
import { isEmbroideryMode } from '@/utils/params';

const getDefaultStyle = (font: StoreFont[]) => {
  return font.find((f) => f.style === 'normal' && f.weight === 'normal');
};

export const getDefaultFont = (fonts: StoreFontFamily[]): StoreFont => {
  const arial = fonts.find((f) => f.name === 'Arial');
  let font = fonts[0].fonts[0];

  if (isEmbroideryMode()) {
    const flipcast = fonts.find((f) => f.name === 'Flipcast');
    font = (flipcast && getDefaultStyle(flipcast.fonts)) || font;
  } else if (arial) {
    font = getDefaultStyle(arial.fonts) || font;
  }
  return font;
};
